module.exports = __webpack_public_path__ + "img/SMP_profil-168297071-1400x900.655806c6.jpg";